module.exports = __webpack_public_path__ + "media/images/countrysquared/cy-8bba76b0371782c75190045c58ef9750.svg";